var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.833V19.5H3.666v-1.667H12Zm8.333-6.666v1.666H3.667v-1.666h16.666Zm0-6.667v1.667H3.667V4.5h16.666Z",
    fill: "#303030"
  })));
};
export { SvgMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS45OTk4IDE3LjgzMzNWMTkuNUgzLjY2NjVWMTcuODMzM0gxMS45OTk4Wk0yMC4zMzMyIDExLjE2NjdWMTIuODMzM0gzLjY2NjVWMTEuMTY2N0gyMC4zMzMyWk0yMC4zMzMyIDQuNVY2LjE2NjY3SDMuNjY2NVY0LjVIMjAuMzMzMloiIGZpbGw9IiMzMDMwMzAiLz4KPC9zdmc+Cg==";